<template>
  <div class="flex flex-col-reverse items-center fixed w-10 h-48 gap-5 z-30 right-10 bottom-10">
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>
          <div
            @click.stop="toFeedback"
            class="items-center cursor-pointer flex text-xl w-9 h-9 justify-center rounded-xl text-primary shadow-lg inset-shadow-sm"
          >
            <SvgIcon name="feedback" class="text-4xl"></SvgIcon>
          </div>
        </TooltipTrigger>
        <TooltipContent side="left"> 反馈 </TooltipContent>
      </Tooltip>
    </TooltipProvider>
    <!-- 返回顶部 -->
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>
          <transition name="fade-in-linear">
            <div
              v-if="visible"
              @click.stop="scrollToTop"
              class="items-center cursor-pointer flex text-xl w-9 h-9 justify-center rounded-full bg-white text-primary shadow-lg inset-shadow-sm transition-all duration-200 ease-in-out dark:bg-stone-800"
            >
              <SvgIcon name="backtop"></SvgIcon>
            </div>
          </transition>
        </TooltipTrigger>
        <TooltipContent side="left"> 返回顶部 </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  </div>
</template>
<script setup lang="ts">
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '~/components/ui/tooltip';
const toFeedback = () => {
  //   window.location.href = 'https://txc.qq.com/products/659177';
  window.open('https://txc.qq.com/products/659177', '_blank');
};

const el = shallowRef<HTMLElement>();
const container = shallowRef<Document | HTMLElement>();
const visible = ref(false);
const target = ref<string>('.app-scrollbar');

const scrollToTop = (_event: MouseEvent) => {
  el.value?.scrollTo({ top: 0, behavior: 'smooth' });
};

const handleScroll = () => {
  if (el.value) visible.value = el.value.scrollTop >= 200;
};

onMounted(() => {
  el.value = document.querySelector<HTMLElement>(target.value) ?? undefined;
  container.value = el.value;
  container.value!.addEventListener('scroll', handleScroll);
  handleScroll();
});

onBeforeUnmount(() => {
  container.value!.removeEventListener('scroll', handleScroll);
});
</script>
